import _ from 'lodash';
import classnames from 'classnames';
import createReactClass from 'create-react-class';
import React from 'react';
import PropTypes from 'prop-types';

import Button, { ButtonTypes } from 'components/common/button';
import EditableUser from 'models/editable_user';
import Err from 'models/err';
import ErrorDisplayMixin from 'components/lib/error_display_mixin.jsx';
import Input from 'components/common/input';
import LoadingSpinner from 'components/lib/loading_spinner';
import RoutingGroup from 'models/routing_group';
import UserEditorInboxSelector from './user_editor_inbox_selector';
import UserEditorRoleSelector from './user_editor_role_selector';
import UserEditorTeamList from './user_editor_team_list';

const UserEditorBase = createReactClass({
  mixins: [ErrorDisplayMixin],

  propTypes: {
    errors: PropTypes.arrayOf(PropTypes.instanceOf(Err)).isRequired,
    initialUser: PropTypes.instanceOf(EditableUser).isRequired,
    isResponsePending: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    routingGroups: PropTypes.arrayOf(PropTypes.instanceOf(RoutingGroup)),
    shouldRenderStationId: PropTypes.bool,
    userTeams: PropTypes.arrayOf(String),
  },

  getInitialState() {
    let { disabled, email, name, roleIds, routingGroupIds, stationId } = this.props.initialUser;
    return {
      disabled,
      email,
      focusField: null,
      name,
      roleIds,
      routingGroupIds,
      stationId,
    };
  },

  isNewUser() {
    return this.props.initialUser.isNew();
  },

  onChangeEmail(evt) {
    this.markAsModified('username');
    this.setState({ email: evt.target.value });
  },

  onChangeName(evt) {
    this.markAsModified('name');
    this.setState({ name: evt.target.value });
  },

  onChangeStationId(evt) {
    this.markAsModified('stationId');
    this.setState({ stationId: evt.target.value });
  },

  onChangeRoleIds(roleIds) {
    this.markAsModified('roleIds');
    this.setState({ roleIds });

    if (_.isEqual(roleIds, ['liveboards'])) {
      this.setState({ routingGroupIds: [] });
    }
  },

  onChangeRoutingGroupIds(routingGroupIds) {
    this.markAsModified('routingGroupIds');
    this.setState({ routingGroupIds });
  },

  onClickEnableDisable(evt) {
    evt.target.blur();
    this.setState({ disabled: !this.state.disabled });
  },

  onFocus(field) {
    this.setState({ focusField: field });
  },

  onSubmit() {
    if (this.isSaving()) {
      return;
    }

    this.resetModified();
    let { disabled, email, name, roleIds, routingGroupIds, stationId } = this.state;
    this.props.onSubmit({ disabled, email, id: this.props.initialUser.id, name, roleIds, routingGroupIds, stationId });
  },

  render() {
    let emailClassNames = classnames('userEditor-email', {
      'userEditor-email-error': !!this.getErrorText('username'),
    });
    let roleClassNames = classnames({
      'userEditor-roles-error': !!this.getErrorText('roleIds'),
    });
    return (
      <div className="userEditor">
        <div className="userEditor-wrapper">
          {this.renderEnableDisable()}
          {this.renderName()}
          <div className="userEditor-label userEditor-email-label">Email</div>
          <Input
            autoFocus={this.isNewUser()}
            className={emailClassNames}
            onChange={this.onChangeEmail}
            onFocus={this.onFocus.bind(this, 'username')}
            placeholder="Email"
            value={this.state.email}
            wrapperClassName="userEditor-email-wrapper"
          />
          {this.renderStationId()}
          <UserEditorRoleSelector
            className={roleClassNames}
            onChange={this.onChangeRoleIds}
            value={this.state.roleIds}
          />
          <UserEditorInboxSelector
            inboxes={this.props.routingGroups}
            isDisabled={_.isEqual(this.state.roleIds, ['liveboards'])}
            onChange={this.onChangeRoutingGroupIds}
            value={this.state.routingGroupIds}
          />
          <UserEditorTeamList teams={this.props.userTeams} />
        </div>
        {this.renderFooter()}
      </div>
    );
  },

  renderEnableDisable() {
    if (!this.props.initialUser.id) {
      return null;
    }

    let enableDisableButtonType = this.state.disabled ? ButtonTypes.SECONDARY : ButtonTypes.PRIMARY;

    return (
      <Button
        buttonType={enableDisableButtonType}
        className="userEditor-enableDisableButton"
        onClick={this.onClickEnableDisable}
        tabIndex="-1"
      >
        {this.state.disabled ? 'Disabled' : 'Enabled'}
      </Button>
    );
  },

  renderName() {
    let nameClassNames = classnames('userEditor-name', {
      'userEditor-name-error': !!this.getErrorText('name'),
    });
    return (
      <span>
        <div className="userEditor-label">Name</div>
        <Input
          autoFocus
          className={nameClassNames}
          onChange={this.onChangeName}
          onFocus={this.onFocus.bind(this, 'name')}
          placeholder="Name"
          value={this.state.name}
          wrapperClassName="userEditor-name-wrapper"
        />
      </span>
    );
  },

  renderStationId() {
    if (!this.props.shouldRenderStationId) {
      return null;
    }

    let stationClassNames = classnames('userEditor-stationId', {
      'userEditor-stationId-error': !!this.getErrorText('stationId'),
    });
    return (
      <span>
        <div className="userEditor-label userEditor-stationId-label">Station ID</div>
        <Input
          className={stationClassNames}
          onChange={this.onChangeStationId}
          onFocus={this.onFocus.bind(this, 'stationId')}
          placeholder="Station ID"
          value={this.state.stationId}
          wrapperClassName="userEditor-stationId-wrapper"
        />
      </span>
    );
  },

  renderFooter() {
    return (
      <div className="userEditor-footer">
        <div className="userEditor-footer-wrapper">
          {this.renderError()}
          <Button className="userEditor-footer-cancel" onClick={this.props.onCancel} buttonType={ButtonTypes.TEXT}>
            Cancel
          </Button>
          {this.renderSave()}
        </div>
      </div>
    );
  },

  renderSave() {
    let saveText = this.isSaving() ? null : this.props.initialUser.id ? 'Save' : 'Create';
    return (
      <Button
        className="userEditor-footer-submit"
        onClick={this.onSubmit}
        onMouseDown={evt => evt.preventDefault()}
        buttonType={ButtonTypes.PRIMARY}
      >
        {saveText}
        {this.isSaving() && <LoadingSpinner position="relative" size="12px" />}
      </Button>
    );
  },

  renderError() {
    if (!this.state.showErrors) {
      return null;
    }

    let error = null;
    let firstUnmodifiedError = _.find(this.props.errors, err => !this.state.hasModified[err.attr]);
    if (this.state.focusField) {
      error =
        _.find(this.props.errors, err => err.attr === this.state.focusField && !this.state.hasModified[err.attr]) ||
        firstUnmodifiedError;
    } else {
      error = firstUnmodifiedError;
    }
    if (!error) {
      return null;
    }

    return <span className="userEditor-footer-error">{displayError(error)}</span>;
  },

  isSaving() {
    return this.props.isResponsePending;
  },
});

function displayError(error) {
  let detail = error.detail.replace(/username/gi, 'email');

  return error.code === Err.Code.TAKEN && error.attr === 'stationId'
    ? 'Station ID is already taken'
    : _.upperFirst(detail);
}

// User / Agent Profile / Routing Groups load asynchronously, meaning we won't have a proper initialUser until all three
// load. Since UserEditorBase sets its initial state assuming that initialUser exists, we won't render it until initialUser
// exists.
const UserEditor = props => {
  if (!props.initialUser) {
    return <LoadingSpinner isModal />;
  }

  return <UserEditorBase {...props} />;
};

UserEditor.propTypes = {
  ...UserEditorBase.propTypes,
  initialUser: PropTypes.instanceOf(EditableUser),
};

export { UserEditorBase };

export default UserEditor;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/user_editor/user_editor.jsx